<template lang="pug">
    v-layout(wrap class="m-list-effectiveness")
        v-flex(xs12)
            v-list(v-if="items.length" v-bind="$attrs" v-on="$listeners" title="")
                template(v-for="(item, key) in items")
                    m-card-effectiveness(:item="item" :key="`${key}-${item.name}`" :assessment-id="assessmentId")
                    v-divider(:key="key" v-show="!isLastItem(key)")
            div(v-else class="pa-3")
                e-typography-body-small {{$t(`modules.lists.${name}.empty`)}}

</template>
<script>

import MCardEffectiveness from '@modules/cards/concrete/m-card-effectiveness';
import baseList from "@mixins/components/modules/lists/base";
let name = 'm-list-effectiveness';
export default {
    name: name,
    mixins: [baseList],
    components: { MCardEffectiveness },
    props: {
        name: {
            type: String,
            default: name
        },
        items: {
            type: Array
        },
        assessmentId: {
            type: String
        }
    },
    methods: {
        isLastItem(index) {
            return index === this.items.length - 1
        }
    }
}
</script>
<style lang="scss">
    .m-list-effectiveness {
        .v-divider {
            display: none;
        }
        .v-list {
            background: transparent;

            .m-card {
                background: var(--v-white);
                padding-bottom: .1rem;
                margin: .5rem;
                border-radius: 3px;
                -webkit-box-shadow: 0px 1px 6px 0px rgba(0, 73, 148, 0.61);
                box-shadow: 0px 1px 6px 0px rgba(0, 73, 148, 0.61);
            }
        }
        .effectiveness {
            .m-block-object-actions__wrapper {
                display: none;

                @media (max-width: $md) {
                    display: block;
                }
            }
            .e-typography-heading-3 {
                text-overflow: ellipsis;
                font-size: 1.1rem !important;
            }
            .e-link-nav {
                width: 100%;
            }
            .effectiveness--name {
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }
    }
    .m-accordion-dashboard {
        .v-divider {
            display: block;
        }
        .v-list {
            .m-card {
                padding-bottom: 0rem;
                margin: 0rem;
                border-radius: 0px;
                box-shadow: none;
            }
        }
    }
</style>
